exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-replacements-settings-footer{display:flex;width:100%;justify-content:flex-end;align-items:center}.admin-replacements-editor{width:100%;margin-bottom:1rem}\n", ""]);

// exports
